











import React, { useState } from 'react';
import main14 from './images/main-ads.png';
import javaLogo from './images/js_logo.png';
import clogo from './images/c-logo.png';
import csslogo from './images/css-logo.png';
import pyLogo from './images/py-logo.png';
import phplogo from './images/php-logo.png';
import d1 from './images/d1.png'
import d2 from './images/d2.png'
import d3 from './images/d3.png'
import d4 from './images/d4.png'
import f1 from './images/f1.png'
import f2 from './images/f2.png'
import f3 from './images/f3.png'
import f4 from './images/f4.png'
import f5 from './images/f5.jpeg'
import f6 from './images/f6.png'
import f7 from './images/f7.png'
import b1 from './images/b1.png'
import b2 from './images/b2.png'
import b3 from './images/b3.svg'
import b4 from './images/b4.jpeg'
import b5 from './images/b5.png'



export default function Ads_Management_ser() {
  // State to track the currently active tab
  const [activeTab, setActiveTab] = useState('Tab1');

  // Handle tab click
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Content for each tab
  const renderContent = () => {
    switch (activeTab) {
      case 'Tab1':
        return (
          <div className="tab-contain-full">
            <div className="main-tab-heading1 auto-focus">
              <h1>Programming Languages</h1>
            </div>
            <div className="main-para-area">
              <img src={javaLogo} alt="" />
              <img src={clogo} alt="" />
              <img src={csslogo} alt="" />
              <img src={pyLogo} alt="" />
              <img src={phplogo} alt="" />
              
              {/* <p>
              Our PPC specialists at Raj Digital Marketing break down the basics of paid search and how it functions to help you get started with confidence. Understanding how PPC works gives you a clear edge in launching campaigns that deliver real results.
              </p>
              <p>
              Explore the fundamentals of PPC marketing and discover how our expert pay per click marketing agency can help your business succeed.
              </p> */}
              <p>
                
              </p>
            </div>
          </div>
        );
      case 'Tab2':
        return (
            <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>Databases</h1>
            </div>
            <div className="main-para-area">
            <img src={d1} alt="" />
            <img src={d2} alt="" />
            <img src={d3} alt="" />
            <img src={d4} alt="" />
              
            </div>
          </div>
        );
      case 'Tab3':
        return (
            <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>Frontend</h1>
            </div>
            <div className="main-para-area">
              
            <img src={f1} alt="" />
            <img src={f2} alt="" />
            <img src={f3} alt="" />
            <img src={f4} alt="" />
            <img src={f5} alt="" />
            <img src={f6} alt="" />
            <img src={f7} alt="" />
            </div>
          </div>
        );
      case 'Tab4':
        return (
            <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>Backend</h1>
            </div>
            <div className="main-para-area">
            <img src={b1} alt="" />
            <img src={b2} alt="" />
            <img src={b3} alt="" />
            <img src={b4} alt="" />
            <img src={b5} alt="" />
              {/* <p>
                If your business has clear growth targets, partner with NEXA to achieve these. This is done through
                smart and personalized digital marketing services, creative thinking, and transformative technology,
                ensuring effective and measurable results.
              </p>
              <p>
                Digital Marketing Services that are aligned to your business' growth targets. By implementing a
                strategy-first approach, our team identifies the right approach aligned to the goals of your
                business. This process includes a full competitor audit together with an outline of the messaging,
                content, and services required to achieve your business' growth targets.
              </p> */}
            </div>
          </div>
        );
      // case 'Tab5':
        return (
            <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>PPC Agency That Delivers Results</h1>
            </div>
            <div className="main-para-area">
              
              <p>
              We Optimize Your Paid Accounts to Save You Time and Money
Since 2020, Raj Digital Marketing has been empowering businesses with comprehensive pay-per-click solutions that boost market performance. Our PPC advertising agency leverages data and analytics to scale your campaigns efficiently and help you achieve your marketing goals.

              </p>
              <p>
              Discover how Raj Digital Marketing has transformed digital marketing success for businesses across industries.
              </p>
              {/* <p>
                Digital Marketing Services that are aligned to your business' growth targets. By implementing a
                strategy-first approach, our team identifies the right approach aligned to the goals of your
                business. This process includes a full competitor audit together with an outline of the messaging,
                content, and services required to achieve your business' growth targets.
              </p>
              <p>
                Digital Marketing Services that are aligned to your business' growth targets. By implementing a
                strategy-first approach, our team identifies the right approach aligned to the goals of your
                business. This process includes a full competitor audit together with an outline of the messaging,
                content, and services required to achieve your business' growth targets.
              </p> */}
            </div>
          </div>
        );
      default:
        return <div>Select a tab to see content</div>;
    }
  };

  return (
    <>
      

      <div className="container tabs-ads-main-container">
        <div className="row row-cols-2 tab-area-main">
          <div className="col main-tabs-area">
            <ul className="main-tab-list">
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab1')}autoFocus style={{outline:0}}>
                Programming Languages
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab2')}>
                Databases
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab3')}>
                Frontend
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab4')}>  Backend
                </button>
              </li>
              {/* <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab5')}>
              
                </button>
              </li> */}
            </ul>
          </div>
          <div className="col main-contain-area-tabs">
            {renderContent()}
          </div>
        </div>
      </div>
    </>
  );
}
